<app-viewer-header [title]="'Stadium Camera Details'" [hideOptions]="true" *ngIf="!fullScreenMode" >
  <div  class="content mr-4">
    <app-asset-action [asset]="stadiumData" [type]="'dropdown'">
    </app-asset-action>
  </div>
</app-viewer-header>
<app-stadium-camera-360 [ngClass]="fullScreenMode?'fullScreen':'normal'"  [stadium]="stadium" *ngIf="stadium" ></app-stadium-camera-360>
